<template>
    <div class="p-banner">
        <div class="p-banner-l">
            <video
            id="myVideo"
            class="video-js vjs-default-skin vjs-big-play-centered vjs-progress-holder"
            ref="viodeRef"
            poster="../../../static/home/black.jpg"
            >
            <source
                :src="videoUrl" 
                type="application/x-mpegURL"
            >
            <!-- <source
                src="Http://dongyunqichuang.oss-accelerate.aliyuncs.com/muke/video/5c057fd33b6f442f8bd1a6a95e00f55c/d02c5bbca2d648eeb7bc79715ffd949e.m3u8" 
                type="application/x-mpegURL"
            > -->
            </video>
        </div>
        <div class="p-banner-r">
            <div style="height:45px;line-height:45px;padding-left:30px;font-size:15px;font-weight:bold;">相关推荐</div>
            <div class="p-banner-r-item" v-for="(item, index) in recommendList" :key='index'>
                <div class="p-banner-r-i-l" @click="toPlay(item.videoNo,'')">
                    <img :src="item.coverUrl" alt="">
                </div>
                <div class="p-banner-r-i-r" style="font-size:12px;">
                    <!-- 北京市xx副教授朱常在——大数据开发技术 -->
                    {{item.name}}
                    <div style="text-align:right;margin-top:0px;">播放：{{item.playNum}}次</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "p-bannerplayer",
        data () {
            return {
                time:'',
                curTime:0,
                timer:'',  //计时器
                count:0, //时间记录
                outTime:300,  //过时时间(5分钟)
            };
        },
        props:['videoUrl','recommendList','videoCode','videoStartTime'],
        watch: {
            videoUrl(newName, oldName) {
                this.videoUrl = newName;
                //动态修改视频地址
                var player =this.$video(myVideo);      
                player.src(newName);  //视频地址
                player.play(); 
                

                // var  video = document.querySelector('#myVideo');
                // var player = videojs(video);
                // player.disableProgress({
                //     autoDisable: true
                // });
            },
            recommendList(newName, oldName) {
                this.recommendList = newName;
                // console.log('recommendList',newName,oldName,this.recommendList);
            },
            videoCode(newName, oldName) {
                this.videoCode = videoCode;
                // console.log('videoCode',newName,oldName,this.videoCode); 
            },
            videoStartTime(newName, oldName) {
                this.videoStartTime = newName;
                // console.log('开始时间的变动',newName,oldName,this.videoStartTime); 
            }
        }, 
        methods: {
            initVideo() {
                let _this = this;
                //初始化视频方法
                let myPlayer = this.$video(myVideo, {
                    //启动视频播放的唯一方法是使用autoplay属性或通过Player /v1。
                    controls: true,
                    //自动播放属性,muted:静音播放 muted 
                    autoplay: true,
                    //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
                    preload: "auto",    
                    // controls:false,
                    width: "858px",
                    height: "420px",
                    controlBar:{ // 设置控制条组件
                        remainingTimeDisplay:true,
                        progressControl:false,
                        children: [
                            {name: 'playToggle'}, // 播放按钮
                            {
                                name: 'volumePanel', // 音量控制
                                inline: false, // 不使用水平方式
                            },
                            {name: 'FullscreenToggle'}, // 全屏
                        ]
                    },
                },function(){
                    var oneTime = true;
                    //设置当前播放时间
                    this.on("play", function(){
                        // this.currentTime(_this.videoStartTime);
                        // console.log('设置当前播放时间',_this.videoStartTime);
                    });
                    this.on('pause', function () {
                        console.log("视频暂停")
            　　     });


                    this.on('timeupdate',function () {
                        let curTime = this.currentTime();
                        _this.curTime = curTime;
                        //  console.log('timeupdate-------------',curTime);
                        //试看三分钟
                        if(curTime >= 180){
                            if(!localStorage.token){
                                this.pause();
                                _this.toParent('login'); //登录
                            }
                        }
                        if(_this.count >= _this.outTime){
                            this.pause();
                        }
                    })
                    //视频结束
                    this.on('ended', function () {
                　　     oneTime = true;
                        _this.$axios.post("/v1/muke/student/video/insertProgressTime",{
                            videoNo:_this.videoCode, 
                            progressTime:_this.curTime.toFixed(0),
                            complete:1,
                        }).then(({data})=>{
                            if(data.data){
                                _this.toParent('videoEnd',data.data.paper); //播放结束
                            }
                        })
                　　});
                });
            },
            
            toParent(type,list) {
                //播放结束
                if(type == 'videoEnd'){
                    this.$emit('event',true,false,list);
                }else if(type == 'login'){
                    this.$emit('event', false,true);
                }else{

                }
                
            },
            //相关推荐点击播放
            toPlay(code,url){
                //根据视频编号获取视频地址
                this.$axios.post("/v1/muke/student/video/selectVideo",{
                    videoNo:code, 
                }).then(({data})=>{
                    if(data.code == 200){
                        this.videoStart = data.data.progressTime;
                        let videoUrl = data.data.videoUrl;
                        var player = this.$video(myVideo);        
                        player.src(videoUrl); 
                        player.play();
                    }
                })
            },
            //计时器
            timeCount(){
                this.count++;
                if (this.count == this.outTime) {
                    console.log("您因长时间未进行操作导致页面过期");
                }

                
            }
        },
        created(){
            // console.log("视频相关推荐",this.recommendList,this.videoUrl);
        },
        mounted(){
            this.initVideo();

            //计时器
            this.timer = setInterval(()=>{
                this.timeCount()
            },1000);
            //监听键盘
            document.addEventListener('keydown', ()=>{
                this.count = 0;
            })
            let x ;
            let y ;
            //监听鼠标
            document.addEventListener('mousemove', (event)=>{
                let x1 = event.clientX;
                let y1 = event.clientY;
                if (x != x1 || y != y1) {
                    this.count = 0;
                }
                x = x1;
                y = y1;
            })
        },
       
        beforeDestroy:function(){
            //离开页面销毁video实例，避免出现节点不存在 但是flash一直在执行，报 this.el.......is not function
            const videoDom = this.$refs.viodeRef;  //不能用document 获取节点
            this.$video(videoDom).dispose();  
            
            //离开页面 提交播放时间
            this.$axios.post("/v1/muke/student/video/insertProgressTime",{
                videoNo:this.videoCode,  // videoNo // 视频编号
                progressTime:this.curTime.toFixed(0), // progressTime 播放时长
                complete:0,
            }).then(({data})=>{})

            //清除计时器
            clearInterval(this.timer);
        }
    }
</script>

<style lang="less">
    // img{display:block;width:100%;height:100%;}

    .vjs-paused .vjs-big-play-button,
    .vjs-paused.vjs-has-started .vjs-big-play-button {
        display: block;
    }
    .p-banner{
        width:1200px;margin:0 auto;padding:0px 0 46px 0;
        overflow: hidden;
        .p-banner-l{
            width:858px;height:420px;background:#2c7be0;float:left;
        }
        .p-banner-r{
            float:right;width:326px;height:420px;background:#eeeeee;
            .p-banner-r-item{
                overflow: hidden;padding-left:18px;margin-bottom:10px;
                .p-banner-r-i-l{
                    float: left;width:82px;height:52px;background:#ffdb2f;
                    img{
                        display:block;width:82px;height:52px;
                    }
                }
                .p-banner-r-i-r{
                    float: left;padding-left:12px;width:164px;
                    // color: white;
                }
            }
        }
    }
</style>